export default {"src":"/_next/static/media/wriggly-down.6a78d355.svg","height":73,"width":52,"blurWidth":0,"blurHeight":0};